import validate from "/home/runner/work/qx-lunarheart/qx-lunarheart/node_modules/nuxt/dist/pages/runtime/validate.js";
import legacy_45page_45id_45redirect_45global from "/home/runner/work/qx-lunarheart/qx-lunarheart/app/middleware/legacy-page-id-redirect.global.ts";
import manifest_45route_45rule from "/home/runner/work/qx-lunarheart/qx-lunarheart/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  legacy_45page_45id_45redirect_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}